import { render } from "./ChatbotConfig.vue?vue&type=template&id=75c94042&scoped=true"
import script from "./ChatbotConfig.vue?vue&type=script&lang=js"
export * from "./ChatbotConfig.vue?vue&type=script&lang=js"

import "./ChatbotConfig.vue?vue&type=style&index=0&id=75c94042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c94042"]])

export default __exports__